import KunLoading51 from './src/index'

KunLoading51.install = function (Vue) {
	Vue.component(KunLoading51.name, KunLoading51);
}

export default KunLoading51;
